import { computed } from 'vue';
import { ModalDashboardPreviewState, ModalDashboardPreviewStateType } from '@/models/modal.interface';
import store from '@/store';

export default class OverviewCode {

	public isDashboardPreviewModalActive = computed((): boolean => {
		return this.modalDashboardPreviewState.value !== ModalDashboardPreviewState.INACTIVE;
	});

	private modalDashboardPreviewState = computed((): ModalDashboardPreviewStateType => {
		return store.getters.modalDashboardPreviewState();
	});
}
